<template>
   <div class="topContainer">      
     <div class="pageHeader">Past Family Reunion Pictures</div>
      <div class="sectionInfo">
       <div class="sectionContent">
        <img class="image" v-for="(image, i) in images" :src="image" :key="i" @click="index = i">
        <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
      </div>
      </div>
   </div>
</template>
<script>
import {ReunionImages} from '../eventPics.js';
export default {
  data: function () {
     return {  
        images : ReunionImages,
        index: null  
     }
  }
}
</script>
<style scoped>
.topContainer{
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~@/assets/pastReunions.jpg') no-repeat center center fixed;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
     background-size: cover;
    height: 60px;
    width: 100%;
    position: relative;
    z-index: 2;
    border-bottom: 2px solid black;
    box-shadow: 1px 1px #111;
}
.image{
  height: 200px;
  margin: 6px;
}
/* Override */
.vgs{
  top: 100px !important;
}
</style>
